import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from 'src/components/button';
import Loading from 'shared/components/loading';
import Steps from 'shared/components/steps';
import {buttonColors} from 'shared/constants';
import {getMedia, watchMedia} from 'shared/mq';
import styles from './styles.module.scss';

class FooterWithSteps extends React.Component {
  static propTypes = {
    currentStepIndex: PropTypes.number.isRequired,
    numberOfSteps: PropTypes.number.isRequired,
    // Next Button
    onNext: PropTypes.func,
    primaryText: PropTypes.string,
    backText: PropTypes.string,
    primaryActionDisabled: PropTypes.bool,
    primaryActionLoading: PropTypes.bool,
    primaryColor: PropTypes.oneOf(buttonColors),
    // Back Button
    onBack: PropTypes.func,
    backDisabled: PropTypes.bool,
  };

  static defaultProps = {
    primaryText: 'Next',
    backText: 'Back',
  };

  componentDidMount() {
    this.mq = watchMedia(() => {
      this.forceUpdate();
    });
  }

  componentWillUnmount() {
    this.mq.remove();
  }

  render() {
    const mq = getMedia();

    const {
      currentStepIndex,
      numberOfSteps,
      onNext,
      primaryText,
      primaryActionDisabled,
      primaryActionLoading,
      primaryColor,
      onBack,
      backText,
      backDisabled,
    } = this.props;

    return (
      <footer className={styles.container} data-testid="footer">
        <div className={styles.actionsWrapper}>
          <div className={styles.buttonWrapper}>
            {onBack && (
              <Button
                outline
                size={mq.MS_AND_DOWN ? 'small' : 'medium'}
                width={mq.MS_AND_DOWN ? '64px' : '131px'}
                onClick={onBack}
                cy="onboarding-back"
                disabled={backDisabled}
                testId="onboarding-back"
              >
                {backText}
              </Button>
            )}
          </div>

          <Steps currentStepIndex={currentStepIndex} numberOfSteps={numberOfSteps} />

          <div className={classnames(styles.buttonWrapper, styles.right)}>
            <Button
              color={primaryColor ? primaryColor : 'primary'}
              disabled={primaryActionDisabled}
              onClick={onNext}
              type={onNext ? 'button' : 'submit'}
              size={mq.MS_AND_DOWN ? 'small' : 'medium'}
              width={mq.MS_AND_DOWN ? '64px' : '131px'}
              cy="onboarding-next"
              testId="onboarding-next"
            >
              {primaryActionLoading ? <Loading /> : primaryText}
            </Button>
          </div>
        </div>
      </footer>
    );
  }
}

export default FooterWithSteps;
